<template>
  <div class="input-search-in">
    <baseIcon
      class="icon-search-in"
      nameIcon="icon-search-in"
      @click="search"
      width="14"
      height="14"
      v-if="!btnSearch"
    />

    <input
      type="text"
      :placeholder="placeholder"
      :value="textSearch"
      @keydown.enter="search()"
      @input="keyupInput($event)"
      ref="input"
      v-select.focus
    />
    <baseIcon
      class="icon-search-btn"
      nameIcon="icon-search-in-color"
      @click="searchBtn()"
      width="14"
      height="14"
      v-if="btnSearch"
      pathIcon="icons-ganeral"
    />
    <div v-show="textSearch" class="otz-icon no-bg clear-input" @click="clear">
      F
    </div>
  </div>
</template>

<script>
export default {
  props: ["placeholder", "textSearch", "btnSearch"],
  mounted: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
      // this.$refs.input.focus();
      // this.$refs.input.select();
    });
  },
  methods: {
    search() {
      this.$emit("keydown", this.$refs.input);
    },
    searchBtn() {
      this.$emit("click", this.$refs.input);
    },
    keyupInput(e) {
      if (this.btnSearch) return;
      this.$emit("input", e.target);
    },
    clear() {
      this.$refs.input.value = "";
      this.$emit("keyup", this.$refs.input);
      this.$emit("input", this.$refs.input);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-search-in {
  position: relative;
  height: 100%;
  .icon-search-in,
  .icon-search-btn {
    width: 15px;
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
  }
  .icon-search-btn {
    right: auto;
    left: 7px;
    cursor: pointer;
  }
}
input {
  border: 1px solid #e5e5e5;
  border-radius: 17px;
  padding-right: 26px;
  height: 25px;
  line-height: 23px;
  width: 100%;
  transition: 0.3s;
}
.clear-input {
  font-size: 8px;
  position: absolute;
  top: 2px;
  left: 3px;
  width: 20px;
}
input:focus {
  border-color: var(--custom-color1);
}
</style>
